export default __webpack_public_path__ + "static/media/Group9174.6808ccc1.svg";